import React from "react";
import styled from "styled-components";
import PText from "./PText";
import MapImage from "../assets/images/map.png";

const MapStyles = styled.div`
  background: url(${MapImage}) no-repeat center / cover;
  min-height: 400px;
  .container {
    position: relative;
    min-height: 400px;
  }
  .map__card {
    position: absolute;
    right: 10%;
    bottom: 10%;
    padding: 2rem;
    background: var(--deep-dark);
    width: 100%;
    max-width: 300px;
    border-radius: 12px;
  }
  .map__card__heading {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  .map__card__link {
    display: inline-block;
    font-size: 1.6rem;
    margin-top: 3rem;
    text-decoration: underline;
  }
  @media only screen and (max-width: 768px) {
    background-position: 80% center;
  }
  @media only screen and (max-width: 400px) {
    .map__card {
      max-width: none;
      right: auto;
    }
  }
`;
const Map = () => {
  return (
    <MapStyles>
      <div className="container">
        <div className="map__card">
          <h3 className="map__card__heading">Here is me</h3>
          <PText>Latifpur, Bogura, Bangladesh</PText>
          <a
            href="https://www.google.com/maps/place/Colony,+Bogura/@24.8236351,89.3719661,15z/data=!4m5!3m4!1s0x39fc54963113667b:0x5fb88958f3c48e10!8m2!3d24.8228368!4d89.3819521"
            target="_blank"
            rel="noopener noreferrer"
            className="map__card__link"
          >
            Open in Google Map
          </a>
        </div>
      </div>
    </MapStyles>
  );
};

export default Map;
